import script from "./sidebar-list-checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-list-checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar-list-checkbox.vue?vue&type=style&index=0&id=0fe21c86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe21c86"]])

export default __exports__